export default "__VITE_ASSET__C7FP8SdK__"